import { t } from 'translations'
import { MenuStepType } from './schema'

export const apfSteps: { name: MenuStepType; label: () => string }[] = [
    { name: 'activate', label: () => t('studioAPF.form.menuActivate') },
    { name: 'assign', label: () => t('studioAPF.form.menuAssign') },
    { name: 'translations', label: () => t('studioAPF.form.menuTranslations') },
    { name: 'enable', label: () => t('studioAPF.form.menuEnable') },
]

export const isApfStep = (value: string | undefined): value is MenuStepType =>
    apfSteps.some((step) => step.name === value)
